/*import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { config, KeyUri } from '../key';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const Recommended = () => {
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedBooking, setSelectedBooking] = useState({
        route: null,
        date: new Date()
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const userid = localStorage.getItem("userID")?.replace(/"/g, "");

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (userid) {
                    const response = await axios.get(
                        `${KeyUri.BACKEND_URI}/get-bookings-user/${userid}`, config
                    );
                    setOrders(response?.data || []);
                }/*else{
                     const res = await axios.get(
    `${KeyUri.BACKEND_URI}/get-all-locations`, config
  );
  const locs = res.data || [];
  
  const mainRoutes = [
    {
      route: { 
        name: "Gangtok → Siliguri",
        from_location: locs.find(l => l.name === "Gangtok"),
        to_location: locs.find(l => l.name === "Siliguri")
      }
    },
    {
      route: { 
        name: "Bagdogra → Darjeeling",
        from_location: locs.find(l => l.name === "Bagdogra"),
        to_location: locs.find(l => l.name === "Darjeeling")
      }
    },
    {
      route: { 
        name: "Kalimpong → Siliguri",
        from_location: locs.find(l => l.name === "Kalimpong"),
        to_location: locs.find(l => l.name === "Siliguri")
      }
    },
    {
      route: { 
        name: "Siliguri → Pelling",
        from_location: locs.find(l => l.name === "Siliguri"),
        to_location: locs.find(l => l.name === "Pelling")
      }
    }
  ];
  
  setOrders(mainRoutes);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, [userid]);

    // Get unique routes
    const uniqueRoutesMap = new Map();
    orders.forEach(order => {
        if (order?.route?.name && !uniqueRoutesMap.has(order.route.name)) {
            uniqueRoutesMap.set(order.route.name, order);
        }
    });
    const uniqueRoutes = Array.from(uniqueRoutesMap.values());

    const handleDateSubmit = async () => {
        setIsSubmitting(true);
        try {

            const formattedDate = moment(selectedBooking.date).format('YYYY-MM-DD');
            const data = null;
            // data = localStorage.getItem('Selected Data'); 
            console.log("here is elected booking data",selectedBooking)
            const formData = {
                from: selectedBooking?.route?.route?.from_location?._id,
                to: selectedBooking?.route?.route?.to_location?._id,
                pickupStreet: selectedBooking?.route?.pickup_point,
                dropStreet: selectedBooking?.route?.drop_point,
                date: formattedDate,
                seats: selectedBooking?.route?.vehicleId?.category
            };

            console.log("Combined booking data:", formData);
            console.log("Formatted date:", formattedDate);
            await localStorage.setItem('Selected Data',JSON.stringify(formData));
            navigate("/sharedcabs");


            setShowModal(false);
            alert('Date saved successfully!');
        } catch (error) {
            console.error("Error storing booking:", error);
            alert('Error saving details. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="max-w-4xl mx-auto my-4 px-4 font-lato">
            {/* Modal 
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 w-96">
                        <h2 className="text-xl font-semibold mb-4">
                            Select Travelling Date for {selectedBooking.route?.route?.name}
                        </h2>
                        <DatePicker
                            selected={selectedBooking.date}
                            onChange={(date) => setSelectedBooking(prev => ({
                                ...prev,
                                date: date
                            }))}
                            minDate={new Date()}
                            className="w-full p-2 border rounded mb-4"
                            dateFormat="dd/MM/yyyy"
                        />
                        <div className="flex justify-end gap-2">
                            <button
                                onClick={() => setShowModal(false)}
                                className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDateSubmit}
                                disabled={isSubmitting}
                                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-blue-300"
                            >
                                {isSubmitting ? 'Searching...' : 'Search Cabs'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Main Content 
            <div className="bg-white rounded-3xl shadow-lg p-8 md:p-10 relative z-10">
                <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8 text-gray-800">
                    Previous Rides
                </h1>

                {isLoading ? (
                    <div className="text-center py-8">
                        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-teal-500"></div>
                        <p className="mt-2 text-gray-500">Loading routes...</p>
                    </div>
                ) : uniqueRoutes.length > 0 ? (
                    <div className="flex flex-wrap gap-4 justify-center">
                     {uniqueRoutes.map((route, index) => (
  <button
    key={index}
    className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors duration-200"
    onClick={() => {
      if (userid) {
        // logged-in user → same as before (open modal for date)
        setSelectedBooking({
          route: route,
          date: new Date()
        });
        setShowModal(true);
      } else {
        // guest user → store prefill route and go to booking form
        const prefillData = {
          from: route?.route?.from_location?._id,
          to: route?.route?.to_location?._id
        };
        localStorage.setItem("prefillRoute", JSON.stringify(prefillData));
        navigate("/bookCabs", { state: { scrollToBooking: true } });
      }
    }}
  >
    {route.route?.name}
  </button>
))}

                    </div>
                ) : (
                    <div className="text-center py-8 text-gray-500">
                        Start your journey now
                    </div>
                )}
            </div>
        </div>
    );
};

export default Recommended;*/

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PreviousRides from './previousRide';
import QuickRoutes from './QuickRoutes';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

const Recommended = () => {
  const navigate = useNavigate();
  const userid = localStorage.getItem("userID")?.replace(/"/g, "");
  const [showModal, setShowModal] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [selectedBooking, setSelectedBooking] = useState({
    date: null,
    pickupStreet: null,
    dropStreet: null,
    fromLocation: null,
    toLocation: null,
    preferredVehicleType: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const openModalForRoute = (route) => {
    if (userid) {
      setSelectedRoute(route);
      setSelectedBooking({ date: new Date() });
      setShowModal(true);
    } else {
      // guest user: store only essential info
      const mapLocation = (loc) => {
        if (!loc) return { _id: null, name: "", points: [] };
        return {
          _id: loc._id || null,
          name: loc.name || "",
          points: Array.isArray(loc.points)
            ? loc.points
              .filter(p => p && p._id)
              .map(p => ({
                id: String(p._id),   // string ID
                location: p.location || ""
              }))
            : []
        };
      };


      setSelectedRoute(route);
      setSelectedBooking(prev => ({ 
        ...prev,
         date: null, 
        fromLocation: route.from_location_id || { _id: null, name: "", points: [] }, 
        toLocation: route.to_location_id || { _id: null, name: "", points: [] }, 
        pickupStreet: route.from_location_id?.points || null, 
        dropStreet: route.to_location_id?.points || null, preferredVehicleType: "" }));


      setShowModal(true);
    }
  };


  const handleDateSubmit = async () => {
    setIsSubmitting(true);
    try {
      const formattedDate = moment(selectedBooking.date).format('YYYY-MM-DD');

      if (!userid) {
        // Validate guest selections:
        if (!selectedBooking.pickupStreet || !selectedBooking.dropStreet) {
          alert('Please select pickup and drop streets.');
          setIsSubmitting(false);
          return;
        }
      }

      
      // Prepare booking payload
      const formData = userid
        ? {
            // logged-in (previous rides)
            from: selectedRoute?.route?.from_location?._id,
            to: selectedRoute?.route?.to_location?._id,
            pickupStreet:
              selectedRoute?.route?.pickup_point || selectedRoute?.pickup_point,
            dropStreet:
              selectedRoute?.route?.drop_point || selectedRoute?.drop_point,
            date: formattedDate,
            seats:
              selectedRoute?.route?.vehicleId?.category ||
              "Standard",
          }
        : {
            // guest user (quick booking)
            from: selectedBooking.fromLocation?._id,
            to: selectedBooking.toLocation?._id,
            pickupStreet: selectedBooking.pickupStreet?.location,
            dropStreet: selectedBooking.dropStreet?.location,
            date: formattedDate,
            seats: selectedBooking.preferredVehicleType || "Standard",
          };


    //  console.log("Booking payload:", formData);

      // You can save the formData and navigate or continue booking flow here

      //setShowModal(false);
      // await localStorage.setItem('Selected Data',JSON.stringify(formData));
      //navigate("/sharedcabs");


      setShowModal(false);
      await localStorage.setItem('Selected Data', JSON.stringify(formData));
      navigate("/sharedcabs");
     // alert('Date saved successfully!');
    } catch (error) {
      console.error("Error submitting booking:", error);
      alert('Failed to save booking. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto my-4 px-4 font-lato mb-100 mt-500">
      <div className="bg-white rounded-2xl shadow-2xl p-6 h-24 overflow-x-auto -mb-4">
        <h1 className="text-2xl font-semibold text-center mb-4 -mt-3">
          {userid ? "Previous Rides" : "Quick Books"}
        </h1>

        {userid ? (
          <PreviousRides userid={userid} onSelectRoute={openModalForRoute} />
        ) : (
          <QuickRoutes onSelectRoute={openModalForRoute} />
        )}

        {/* Modal */}
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-96">
              <h2 className="text-xl font-semibold mb-4">
                {userid
                  ? `Select Traveling Date for ${selectedRoute.route?.name || selectedRoute.name}`
                  : `Book Ride: ${selectedRoute.name}`}
              </h2>

              {!userid && (
                <>


                  <label className="block mb-1 font-medium">Pickup Point</label>
                  <select
                    value={selectedBooking.pickupStreet?.id || ""}
                    onChange={(e) => {
                      const selectedPoint = selectedBooking.fromLocation?.points.find(
                        (point) => point.id === e.target.value
                      );
                      setSelectedBooking((prev) => ({ ...prev, pickupStreet: selectedPoint || null }));
                    }}
                    className="w-full p-2 border rounded mb-4"
                  >
                    <option value="">Select Pickup Point</option>
                    {selectedBooking.fromLocation?.points?.map((point) => (
                      <option key={point.id} value={point.id}>{point.location}</option>
                    ))}
                  </select>



                  <label className="block mb-1 font-medium">Drop Point</label>
                  <select
                    value={selectedBooking.dropStreet?.id || ""}
                    onChange={(e) => {
                      const selectedPoint = selectedBooking.toLocation?.points.find(
                        (point) => point.id === e.target.value
                      );
                      setSelectedBooking((prev) => ({ ...prev, dropStreet: selectedPoint || null }));
                    }}
                    className="w-full p-2 border rounded mb-4"
                  >
                    <option value="">Select Drop Point</option>
                    {selectedBooking.toLocation?.points?.map((point) => (
                      <option key={point.id} value={point.id}>{point.location}</option>
                    ))}
                  </select>



                  {/* Preferred Vehicle Type Dropdown */}
                  <label className="block mb-1 font-medium">Preferred Vehicle Type</label>
                  <select
                    value={selectedBooking.preferredVehicleType}
                    onChange={(e) => setSelectedBooking(prev => ({
                      ...prev,
                      preferredVehicleType: e.target.value,
                    }))}
                    className="w-full p-2 border rounded mb-4"
                  >
                    <option value="">Select Vehicle Type</option>
                    <option value="Economy">Economy</option>
                    <option value="Standard">Standard</option>
                    <option value="Luxury">Luxury</option>
                  </select>

                </>
              )}
              <label className="block mb-1 font-medium">Date of Travel</label>
              <DatePicker
                selected={selectedBooking.date}
                onChange={(date) =>
                  setSelectedBooking((prev) => ({
                    ...prev,
                    date: date,
                  }))
                }
                minDate={new Date()}
                className="w-full p-2 border rounded mb-4"
                 placeholderText="Select a date"  
                dateFormat="dd/MM/yyyy"
              />

              <div className="flex justify-end gap-2">
                <button
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
                >
                  Cancel
                </button>
                <button
                  onClick={handleDateSubmit}
                  disabled={isSubmitting || (!userid && (!selectedBooking.pickupStreet || !selectedBooking.dropStreet))}
                  className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-blue-300"
                >
                  {isSubmitting ? "Searching..." : "Search Cabs"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Recommended;
